export default __webpack_public_path__ + "static/media/avatar.2a8183ec.jpeg";